import Model, { attr } from '@ember-data/model';

export default class AutoresponderModel extends Model {
  @attr('boolean') enabled!: boolean;
  @attr('number') delayInMinutes!: number;
  @attr('boolean') autoAccept!: boolean;
  @attr('string', { defaultValue: '' }) message!: string;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    autoresponder: AutoresponderModel;
  }
}
